import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import preview from './preview/marketplace_system/marketplace_system.png';
import thumbnail from './preview/marketplace_system/marketplace_system_thumbnail.png';

CustomViewPages.register({
  id: 'marketplace_system',
  meta: {
    label: 'System Detail Page',
    category: CustomViewPageCategory.MARKETPLACE,
    typeId: {
      type: CustomViewTypeIdType.SYSTEM_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.SYSTEM_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  function: function DataProduct() {
    const configApi = useApi(configApiRef);
    const isMultipleAccessRequestEnabled = configApi.getOptionalBoolean(
      'mesh.marketplace.multipleAccessRequestSelection',
    );

    return (
      <CustomViewComponent type="grid_list">
        <CustomViewComponent type="include" id="marketplace_system_general" />
        <CustomViewComponent
          type="marketplace_tech_card"
          configs={configApi.getOptionalStringArray(
            'mesh.marketplace.ui.dataProductPage.technicalInformation',
          )}
        />
        <CustomViewComponent type="hbox" responsive>
          <CustomViewComponent type="grid_list" size={2}>
            <CustomViewComponent type="grid_sequence" path="_componentsByKind">
              <CustomViewComponent
                type="marketplace_component_card"
                title="{{ label }}"
              >
                <CustomViewComponent
                  type="table"
                  path="components"
                  click="showComponent"
                  filters={[
                    {
                      type: 'search',
                      column: 'Name',
                    },
                    {
                      type: 'multiselect',
                      column: 'Type',
                    },
                    {
                      type: 'multiselect',
                      column: 'Technology',
                    },
                    {
                      column: 'Access',
                      type: 'boolean',
                    },
                  ]}
                >
                  <CustomViewComponent
                    type={isMultipleAccessRequestEnabled ? 'checkbox' : 'radio'}
                    path="selected"
                    label=""
                    width="50"
                    maxWidth="50"
                    minWidth="50"
                    click="setSelection"
                    disabled="{% if shoppable is null or _parent._parent._computedInfo.shoppable === 'SHOPPABLE' %} true {% else %} false {% endif %}"
                    disabledTooltip="The project owner has not enabled individual access requests for this consumable "
                    resizable={false}
                  />
                  <CustomViewComponent
                    type="string"
                    path="name"
                    label="Name"
                    width="35%"
                    sortable
                  />
                  <CustomViewComponent type="string" path="type" label="Type" />
                  <CustomViewComponent
                    type="string"
                    path="version"
                    label="Version"
                  />
                  <CustomViewComponent
                    type="string"
                    path="descriptor.technology"
                    label="Technology"
                  />
                  <CustomViewComponent
                    type="icon"
                    path="accessStatus.summary"
                    label="Access"
                    tooltip="{{accessStatus.description}}"
                    map={{
                      access: 'has_access',
                      partial_access: 'partial_access',
                      non_consumable: 'no_access',
                      no_access: 'no_access',
                    }}
                  />
                </CustomViewComponent>
              </CustomViewComponent>
            </CustomViewComponent>
          </CustomViewComponent>
          <CustomViewComponent type="grid_list" size={1}>
            <CustomViewComponent type="marketplace_review" />
            <CustomViewComponent type="marketplace_questions" />
          </CustomViewComponent>
        </CustomViewComponent>
      </CustomViewComponent>
    );
  },
});
